import { YeuCauDuyetGiaConfig, YeuCauDuyetGiaList } from './../yeu-cau-duyet-gia-model/yeu-cau-duyet-gia.model';
import { DungChungService } from './../../../dung-chung/__services/dung-chung.service';
import { ItemsActions } from './../../../../TemplateDemo/ex-template/ex-template.actions';
import { Component, OnInit, ElementRef, ViewChild, ChangeDetectionStrategy, ChangeDetectorRef, HostListener, ViewChildren, ViewRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DatePipe } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
// Material
import { MatPaginator, MatSort, MatDialog, MatTableDataSource, MatMenuTrigger } from '@angular/material';
import { SelectionModel } from '@angular/cdk/collections';
import { CdkDragStart, CdkDropList, moveItemInArray } from '@angular/cdk/drag-drop';
// RXJS
import { debounceTime, distinctUntilChanged, tap } from 'rxjs/operators';
import { ReplaySubject, fromEvent, merge, BehaviorSubject } from 'rxjs';
//Datasource
import { YeuCauDuyetGiaDataSource } from '../yeu-cau-duyet-gia-datasource/yeu-cau-duyet-gia.datasource';
//Service
import { YeuCauDuyetGiaService } from '../yeu-cau-duyet-gia-service/yeu-cau-duyet-gia.service';
import { SubheaderService } from '../../../../../../core/_base/layout';
import { LayoutUtilsService, QueryParamsModel, MessageType } from '../../../../../../core/_base/crud';
import { YeuCauDuyetGiaEditComponent } from '../yeu-cau-duyet-gia-edit/yeu-cau-duyet-gia-edit.component';
import { environment } from '../../../../../../../environments/environment';
import { DynamicSearchFormService } from '../../../../components/dynamic-search-form/dynamic-search-form.service';
//Model
import { YeuCauDuyetGia, YeuCauDuyetGiaChiTiet } from '../yeu-cau-duyet-gia-model/yeu-cau-duyet-gia.model';
import { TokenStorage } from '../../../../../../core/auth/_services';
import { CommonConFig } from '../../../dung-chung/__model/common_config.model';
import { FunctionPublic } from '../../../dung-chung/__function/common_function';
import { GuiLaiDuyetGiaComponent } from '../gui-lai-duyet-gia/gui-lai-duyet-gia.component';
import moment from 'moment';
import * as xlsx from 'xlsx';
import { KDDatHangEditComponent } from '../../kd-dat-hang/kd-dat-hang-edit/kd-dat-hang-edit.component';
import { KDDatHang, KDDatHangChiTiet } from '../../kd-dat-hang/kd-dat-hang-model/kd-dat-hang.model';
import { KDDatHangService } from '../../kd-dat-hang/kd-dat-hang-service/kd-dat-hang.service';
import { KhachHangFeedbackComponent } from '../khach-hang-feedback/khach-hang-feedback.component';

@Component({
	selector: 'm-yeu-cau-duyet-gia-list',
	templateUrl: './yeu-cau-duyet-gia-list.component.html',
	styleUrls: ['../yeu-cau-duyet-gia.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	providers: [DatePipe]
})
export class YeuCauDuyetGiaListComponent implements OnInit {
	CONFIG: CommonConFig;
	// Table fields
	dataSource: YeuCauDuyetGiaDataSource;
	displayedColumns = [];
	availableColumns = [
		{
			stt: 1,
			name: '#',
			displayName: '#',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 2,
			name: 'SOPHIEU',
			displayName: 'Số phiếu',
			alwaysChecked: false,
			isShow: true
		},

		{
			stt: 3,
			name: 'MAKHTENKH',
			displayName: 'Mã KH - Tên KH',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 4,
			name: 'MaHHTenHH',
			displayName: 'Mã hàng - Tên hàng',
			alwaysChecked: false,
			isShow: true
		},

		{
			stt: 5,
			name: 'SOLUONG',
			displayName: 'Số lượng',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 6,
			name: 'DVT',
			displayName: 'DVT',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 7,
			name: 'GIAHIENTAI',
			displayName: 'Giá hiện tại',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 8,
			name: 'GIAKHACHHANGMONGMUON',
			displayName: 'Giá KH đề nghị',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 9,
			name: 'GIADENGHIBAN',
			displayName: 'Giá đề nghị bán',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 10,
			name: 'KHOANGGIA',
			// displayName: 'Khoảng giá',
			displayName: 'Mức giá tối thiểu',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 11,
			name: 'KHFeedback',
			// displayName: 'Khoảng giá',
			displayName: 'KH Feedback',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 12,
			name: 'TRANGTHAI',
			displayName: 'Trạng thái',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 13,
			name: 'NGUOILAP',
			displayName: 'Người lập phiếu',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 14,
			name: 'NGAYLAPPHIEU',
			displayName: 'Ngày lập phiếu',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 99,
			name: 'ACTIONS',
			displayName: 'Thao tác',
			alwaysChecked: true,
			isShow: true
		}
	];

	@ViewChildren('focus') focus;
	@ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
	@ViewChild('sort1', { static: true }) sort: MatSort;
	@ViewChild('trigger', { static: true }) _trigger: MatMenuTrigger;

	// Filter fields
	@ViewChild('searchTuNgay', { static: true }) searchTuNgay: ElementRef;
	@ViewChild('searchDenNgay', { static: true }) searchDenNgay: ElementRef;
	minDate: string = "";
	maxDate: string = "";
	@ViewChild('keywordSearch', { static: true }) keywordSearch: ElementRef;

	// Selection
	selectedColumns = new SelectionModel<any>(true, this.availableColumns);
	selection = new SelectionModel<YeuCauDuyetGia>(true, []);

	YeuCauDuyetGiaResult: YeuCauDuyetGia[] = [];
	tmpYeuCauDuyetGiaResult: YeuCauDuyetGia[] = [];

	loadingSubject = new BehaviorSubject<boolean>(false);
	loading$ = this.loadingSubject.asObservable();

	saveNewTTHV: number[] = []
	flagHighlight: boolean = false;

	previousIndex: number;
	fixedPoint = 2;

	_openThem: boolean = false;

	//ROLES
	TAO = ['CREATE_YCDG_B2B', 'CREATE_YCDG_B2C'];
	HUY = ['CANCEL_YCDG_B2B', 'CANCEL_YCDG_B2C'];

	LIST_ROLES_USER: [] = [];

	SHOW_BUTTON_CREATE = new BehaviorSubject<boolean>(false);
	SHOW_BUTTON_CANCEL = new BehaviorSubject<boolean>(false);

	//filter on grid
	haveFilter: boolean = false;
	filterGroupDataChecked: any = {};
	filterGroupDataCheckedFake: any = {};
	filterGroupData: any = {};
	filterGroupArray: any = {};
	filterText: any = {};
	tmpfilterText: any = {};

	listListYCBG: any[] = [];
	selectListYCBG: string = '';
	filteredListYCBG: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
	ListYCBGFilterCtrl: string = '';
	haveElementListYCBG: boolean = false;

	listId_HH: any[] = [];
	selectId_HH: string = '';
	filteredId_HH: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
	Id_HHFilterCtrl: string = '';
	haveElementId_HH: boolean = false;

	//list sản phẩm báo giá
	list_SanPhamBaoGia: any[] = [];
	select_SanPhamBaoGia: string = '';
	filtered_SanPhamBaoGia: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
	SanPhamBaoGiaFilterCtrl: string = '';
	haveElement_SanPhamBaoGia: boolean = false;
	//end

	/* KHAI BÁO Ở MODEL*/
	// category_path = "KDYCDG";
	optionsTinhTrang = YeuCauDuyetGia.optionsTinhTrang;

	openDialog: boolean = false;
	IdUser = 0;
	keywordsearch: string = '';
	// filter on grid
	disableButtonFilter: any = {};
	isClearAll: boolean = false;
	public datatree: BehaviorSubject<any[]> = new BehaviorSubject([]);
	CoQuyen: string = '0';

	__idYCBG = '';

	/* --------------------------- Xuất excel ----------------------------*/
	flagExportFile = false;
	waittingExport: boolean = false;
	/* ------------------------------------------------------------------ */
	/* --------------------------- B2B & B2C ----------------------------*/
	BusinessType: string = "";
	BusinessUrl: string = "";
	BusinessTitle: string = "";
	/* ----------------------------------------------------------------- */
	@HostListener('window:keyup', ['$event'])
	keyEvent(event: KeyboardEvent) {
		if (event.altKey && event.keyCode == 78 && !this.openDialog) {
			this.openDialog = true;
			this.addYeuCauDuyetGia();
		}
	}

	constructor(
		private YeuCauDuyetGiaService: YeuCauDuyetGiaService,
		private DungChungService: DungChungService,
		public dialog: MatDialog,
		private activatedRoute: ActivatedRoute,
		private router: Router,	
		private datePipe: DatePipe,
		private translate: TranslateService,
		private subheaderService: SubheaderService,
		private changeDetect: ChangeDetectorRef,
		private tokenStorage: TokenStorage,
		private layoutUtilsService: LayoutUtilsService,
		private dynamicSearchFormService: DynamicSearchFormService,
		private KDDatHangService: KDDatHangService,
	) {
		let user = JSON.parse(localStorage.getItem("UserInfo"));
		this.LIST_ROLES_USER = user.roles;
		this.router.routeReuseStrategy.shouldReuseRoute = function () {
			return false;
		};
		const SiteUrl = this.router.url.split("/")[1];
		if ([YeuCauDuyetGiaConfig.B2B.PARAM_REQUEST_PRICE, YeuCauDuyetGiaConfig.B2C.PARAM_REQUEST_PRICE].includes(SiteUrl)) {
		
			let currentConfig = SiteUrl === YeuCauDuyetGiaConfig.B2B.PARAM_REQUEST_PRICE 
				? YeuCauDuyetGiaConfig.B2B 
				: YeuCauDuyetGiaConfig.B2C;
		
			this.BusinessTitle = currentConfig.TITLE_REQUEST_PRICE;
			this.BusinessType = currentConfig.BUSINESS_TYPE;
			this.BusinessUrl = SiteUrl;
		}
	}

	//#region LOAD DATA
	ngOnInit() {
		/*Load cấu hình config form */
		this.CONFIG = new CommonConFig();
		this.CONFIG.PAGE_SIZE_LIST = environment.pageSize;

		// Lấy IdUser đăng nhập
		this.tokenStorage.getIDUser().subscribe(t => {
			this.IdUser = +t;
		});

		// Set value filter
		this.haveFilter = true;
		this.disableButtonFilter['TrangThai'] = true;
		this.disableButtonFilter['MaSP'] = true;
		this.disableButtonFilter['MaKH'] = true;
		this.disableButtonFilter['TenNguoiLapPhieu'] = true;
		this.tmpfilterText = Object.assign({}, this.filterText);
		this.filterText['TuNgay'] = "";
		this.filterText['DenNgay'] = "";

		// Set SoPhieu
		// this.filterGroupDataChecked['SoPhieu'] = '';
		this.filterGroupDataChecked['TenNguoiLapPhieu'] = '';
		this.filterGroupDataChecked['MaKH'] = '';
		this.filterGroupDataCheckedFake = Object.assign({}, this.filterGroupDataChecked);

		this.callServiceFilterInList();
		// this.getYCBGLite();
		// this.ListSanPhamYeuCauBaoGia();

		this.showColumnsInTable();
		this.applySelectedColumns();

		this.activatedRoute.queryParams.subscribe(params => {
			if (params['SoPhieu']) this.selectListYCBG = params['SoPhieu'];
			if (params['IdCt']) this.select_SanPhamBaoGia = params['IdCt'];
			
			// if(params['sophieu'] && params['idhh']) 
			// 	this.router.navigateByUrl('/kd-yeu-cau-duyet-gia',{ relativeTo: this.activatedRoute });
		});

		//Set chức năng button
		this.SHOW_BUTTON_CREATE.next(this.isTrueButton(this.TAO));
		this.SHOW_BUTTON_CANCEL.next(this.isTrueButton(this.HUY));

		// If the YeuCauDuyetGiaTmp changes the sort , reset back to the first page.
		this.sort.sortChange.subscribe(() => (this.paginator.pageIndex = 0));
		merge(this.sort.sortChange, this.paginator.page).pipe(
			tap(() => {
				this.loadYeuCauDuyetGia();
				this.forcusEvents();
			})
		).subscribe();
		//Set title to page breadCrumbs
		let breadcrumbs = [{ title: 'Kinh doanh' }, { title: this.BusinessTitle , page: '/' + this.BusinessUrl }];
		this.subheaderService.setBreadcrumbs(breadcrumbs);

		// Init DataSource
		this.dataSource = new YeuCauDuyetGiaDataSource(this.YeuCauDuyetGiaService);
		let queryParams = new QueryParamsModel({});

		this.dataSource.entitySubject.subscribe(res => {
			this.YeuCauDuyetGiaResult = res
			this.tmpYeuCauDuyetGiaResult = []
			if (this.YeuCauDuyetGiaResult != null) {
				for (let i = 0; i < this.YeuCauDuyetGiaResult.length; i++) {
					let tmpElement = new YeuCauDuyetGia();
					tmpElement.copy(this.YeuCauDuyetGiaResult[i])
					this.tmpYeuCauDuyetGiaResult.push(tmpElement);
				}
			}
		});
		this.loadYeuCauDuyetGia();

		let ids: number[] = [];
		this.YeuCauDuyetGiaService.CheckThoiHanGiuGia(ids).toPromise();

		this.layoutUtilsService.setUpPaginationLabels(this.paginator);

		let opt = {
			title: 'Tìm kiếm theo: Số phiếu, Mã KH, Tên KH, Mã hàng, Tên hàng',
			searchbox: 'Search',
			controls: [{
				type: 0,
				name: 'Search',
				placeholder: 'Từ khóa',
			}]
		}
		this.dynamicSearchFormService.setOption(opt);
		this.dynamicSearchFormService.filterResult.subscribe(value => {
			if (Object.keys(value).length > 0) {
				this.keywordsearch = value.Search;
				this.loadYeuCauDuyetGia();
			}
			else {
				this.keywordsearch = "";
				this.loadYeuCauDuyetGia();
			}
		});
	}
	//#endregion LOAD DATA

	//#region AferView
	ngAfterViewInit() {
		this.changeDetect.detectChanges();
	}
	//#endregion AfterView

	f_number(item: any = "0.00") {
		return FunctionPublic.F_NUMBER(item);
	}


	async getYCBGLite() {
		let res = await this.YeuCauDuyetGiaService.lite().toPromise();
		if (res && res.status == 1) {
			this.listListYCBG = res.data;
			this.listListYCBG.unshift({ Id: '', SoPhieu: 'Tất cả' });
			this.filteredListYCBG.next(this.listListYCBG.slice());
			//this.changeDetectView();
		} else {

			this.layoutUtilsService.showErorr(res.error.message);
		}
	}

	filterListYCBG() {
		if (!this.listListYCBG) {
			return;
		}
		// get the search keyword
		let search = this.ListYCBGFilterCtrl;
		if (!search) {
			this.filteredListYCBG.next(this.listListYCBG.slice());
			return;
		} else {
			search = search.toLowerCase();
		}
		this.filteredListYCBG.next(
			this.listListYCBG.filter(ts =>
				ts.SoPhieu.toLowerCase().indexOf(search) > -1)
		);
		this.changeDetectView();
	}

	changePhieuBG() {
		if (!this.selectListYCBG) {
			this.list_SanPhamBaoGia = [];
			this.select_SanPhamBaoGia = '';
			this.filtered_SanPhamBaoGia.next(this.list_SanPhamBaoGia.slice());
			this.loadYeuCauDuyetGiaInit(false);
			this.changeDetectView();

		} else {
			this.DungChungService.layDanhSachSanPhamTheoPhieuBaoGia(this.selectListYCBG).subscribe(res => {
				if (res && res.status == 1) {
					this.list_SanPhamBaoGia = res.data;
					this.filtered_SanPhamBaoGia.next(this.list_SanPhamBaoGia.slice());
					this.changeDetectView();
				} else {

					this.layoutUtilsService.showErorr(res.error.message);
				}
			})
		}


	}


	changeSanPham() {
		this.loadYeuCauDuyetGiaInit(false);
	}

	ListSanPhamYeuCauBaoGia() {
		this.DungChungService.layDanhSachSanPhamYeuCauBaoGia().subscribe(res => {
			if (res && res.status === 1) {
				this.list_SanPhamBaoGia = res.data;
				this.filtered_SanPhamBaoGia.next(this.list_SanPhamBaoGia.slice());
				this.changeDetectView();
			} else {

				this.layoutUtilsService.showErorr(res.error.message);
			}
		});

	}
	filterSanPhamYeuCauBaoGia() {
		if (!this.list_SanPhamBaoGia) {
			return;
		}
		// get the search keyword
		let search = this.SanPhamBaoGiaFilterCtrl;
		if (!search) {
			this.filtered_SanPhamBaoGia.next(this.list_SanPhamBaoGia.slice());
			return;
		} else {
			search = search.toLowerCase();
		}
		this.filtered_SanPhamBaoGia.next(
			this.list_SanPhamBaoGia.filter(ts =>
				ts.TenSanPham.toLowerCase().indexOf(search) > -1)
		);
		this.changeDetectView();
	}

	async ListId_HH() {
		let res = await this.DungChungService.listHangHoa().toPromise();
		if (res && res.status === 1) {
			this.listId_HH = res.data;
			this.filteredId_HH.next(this.listId_HH.slice());
			this.changeDetectView();
		} else {

			this.layoutUtilsService.showErorr(res.error.message);
		}
	}
	filterId_HH() {
		if (!this.listId_HH) {
			return;
		}
		// get the search keyword
		let search = this.Id_HHFilterCtrl;
		if (!search) {
			this.filteredId_HH.next(this.listId_HH.slice());
			return;
		} else {
			search = search.toLowerCase();
		}
		this.filteredId_HH.next(
			this.listId_HH.filter(ts =>
				ts.Ma_Ten_HH.toLowerCase().indexOf(search) > -1)
		);
		this.changeDetectView();
	}


	//#region Function check quyền
	isTrueButton(ROLENUMBER: string[]) {
		if (this.LIST_ROLES_USER.findIndex(x => ROLENUMBER.includes(x)) > -1) {
			return true;
		}
		return false;
	}
	//#endregion Function check quy

	//#region Load danh sach
	// Default
	loadYeuCauDuyetGia(highlight: boolean = false) {
		if (highlight == false) this.saveNewTTHV = [];
		this.selection.clear();
		const queryParams = new QueryParamsModel(
			this.filterConfiguration(),
			this.sort.direction,
			this.sort.active,
			this.paginator.pageIndex,
			this.paginator.pageSize,
			this.filterGroupData
		);
		this.dataSource.loadYeuCauDuyetGias(queryParams);

		var data = window.history.state;
		if (data != null && data.saveNewTTHV) {
			this.saveNewTTHV = data.saveNewTTHV;
		}

	}

	// Load danh sách cho trường hợp xóa quay về trang trước đó nếu k còn dữ liệu ở trang đang load
	loadYeuCauDuyetGiaPagePre(highlight: boolean = false) {
		if (highlight == false) this.saveNewTTHV = [];
		this.selection.clear();
		this.paginator.pageIndex = (this.paginator.pageIndex > 0) ? this.paginator.pageIndex - 1 : 0;
		const queryParams = new QueryParamsModel(
			this.filterConfiguration(),
			this.sort.direction,
			this.sort.active,
			this.paginator.pageIndex,
			this.paginator.pageSize,
			this.filterGroupData
		);
		this.dataSource.loadYeuCauDuyetGias(queryParams);

		var data = window.history.state;
		if (data != null && data.saveNewTTHV) {
			this.saveNewTTHV = data.saveNewTTHV;
		}

	}

	// Load danh sách về trang đầu khi thêm hoặc tìm kiếm
	loadYeuCauDuyetGiaInit(highlight: boolean = false) {
		if (highlight == false) this.saveNewTTHV = [];
		this.selection.clear();
		this.paginator.pageIndex = 0;
		const queryParams = new QueryParamsModel(
			this.filterConfiguration(),
			this.sort.direction,
			this.sort.active,
			this.paginator.pageIndex,
			this.paginator.pageSize,
			this.filterGroupData
		);
		this.dataSource.loadYeuCauDuyetGias(queryParams);

		var data = window.history.state;
		if (data != null && data.saveNewTTHV) {
			this.saveNewTTHV = data.saveNewTTHV;
		}

	}
	//#endregion Load danh sach

	//#region FILTRATION
	filterConfiguration(): any {
		const filter: any = {};
		filter.keywordsearch = this.keywordsearch;
		// if (this.filterText) {
		// 	filter.MaKH = this.filterText['MaKH'];
		// }
		filter.BusinessModel = this.BusinessType
		filter.TuNgay = this.filterText['TuNgay'] ? moment(this.filterText['TuNgay']).format("DD/MM/YYYY") : "";
		filter.DenNgay = this.filterText['DenNgay'] ? moment(this.filterText['DenNgay']).format("DD/MM/YYYY") : "";
		return filter;
	}
	//#endregion  FILTRATION

	//#region Apply selected Column
	IsAllColumnsChecked() {
		const numSelected = this.selectedColumns.selected.length;
		const numRows = this.availableColumns.length;
		return numSelected === numRows;
	}
	//#endregion Apply selected Column

	//#region Column
	CheckAllColumns() {
		if (this.IsAllColumnsChecked()) {
			this.availableColumns.forEach(row => { if (!row.alwaysChecked) this.selectedColumns.deselect(row); });
		} else {
			this.availableColumns.forEach(row => this.selectedColumns.select(row));
		}
	}

	showColumnsInTable() {
		for (let i = 0; i < this.availableColumns.length; i++) {
			if (this.availableColumns[i].isShow == false) {
				this.selectedColumns.toggle(this.availableColumns[i]);
			}
		}
	}

	findIndexColumn(column: string) {
		for (let i = 0; i < this.availableColumns.length; i++) {
			if (this.availableColumns[i].name == column)
				return i;
		}
	}

	dragStarted(event: CdkDragStart, column: string) {
		this.previousIndex = this.findIndexColumn(column);
	}

	dropListDropped(event: CdkDropList, column: string) {

		if (event) {
			moveItemInArray(this.availableColumns, this.previousIndex, this.findIndexColumn(column));
			this.applySelectedColumns();
		}
	}

	applySelectedColumns() {
		let _selectedColumns = this.selectedColumns.selected;
		this.selectedColumns = new SelectionModel<any>(true, this.availableColumns);
		for (let i = 0; i < this.availableColumns.length; i++) {
			this.selectedColumns.toggle(this.availableColumns[i]);
			for (let j = 0; j < _selectedColumns.length; j++) {
				if (this.availableColumns[i].name == _selectedColumns[j].name) {
					this.selectedColumns.toggle(this.availableColumns[i]);
					break;
				}
			}
		}
		const _applySelectedColumns: string[] = [];
		this.selectedColumns.selected.forEach(col => { _applySelectedColumns.push(col.name) });
		this.displayedColumns = _applySelectedColumns;
	}

	menuChange(e: any, type: 0 | 1 = 0) {
		this.layoutUtilsService.menuSelectColumns_On_Off();
	}

	//#endregion Column

	//#region Thêm mới, Chỉnh sửa
	async addYeuCauDuyetGia() {
		let newYeuCauDuyetGia = new YeuCauDuyetGiaList();
		newYeuCauDuyetGia.clear();
		this.editYeuCauDuyetGia(newYeuCauDuyetGia, false);
	}
	async editYeuCauDuyetGia(YeuCauDuyetGiaList: YeuCauDuyetGiaList, edit: boolean = true) {

		if (this.checkDashboardRoute()) return null;
		const dialogRef = this.dialog.open(YeuCauDuyetGiaEditComponent, {
			data: {
				data: YeuCauDuyetGiaList,
				add: YeuCauDuyetGiaList.IdDG == 0,
				edit: YeuCauDuyetGiaList.IdDG > 0,
				show_area_1: false,
				BusinessModel : this.BusinessType
			},
			maxHeight: '90vh',
			width: '90vw'
		});
		dialogRef.afterClosed().subscribe(res => {
			this.openDialog = false;
			this.loadYeuCauDuyetGiaInit(true);
			if (res == undefined || res == null) {
				return;
			}
			else {
				if (!res.isChange) {
					this.loadYeuCauDuyetGia();
					return;
				}
				if (res.saveNewTTHV.length != 0) {
					this.saveNewTTHV = res.saveNewTTHV;
				}
				if (YeuCauDuyetGiaList.IdDG == 0)
					this.loadYeuCauDuyetGiaInit(true);
				this.loadYeuCauDuyetGia(true);
			}
		});
	}

	async guilaiduyetgia(YeuCauDuyetGiaList: YeuCauDuyetGiaList) {

		if (this.checkDashboardRoute()) return null;
		const dialogRef = this.dialog.open(GuiLaiDuyetGiaComponent, {
			data: {
				data: YeuCauDuyetGiaList,
				guilai: true,
				show_area_1: false,
			},
			maxHeight: '90vh',
			width: '90vw'
		});
		dialogRef.afterClosed().subscribe(res => {
			this.openDialog = false;
			this.loadYeuCauDuyetGiaInit(true);
			if (res == undefined || res == null) {
				return;
			}
			else {
				if (!res.isChange) {
					this.loadYeuCauDuyetGia();
					return;
				}
				if (res.dataAdd.length != 0) {
					this.saveNewTTHV = res.dataAdd;
				}
				if (YeuCauDuyetGiaList.IdDG == 0)
					this.loadYeuCauDuyetGiaInit(true);
				this.loadYeuCauDuyetGia(true);
			}
		});
	}
	async duplicateYeuCauDuyetGia(detail: YeuCauDuyetGiaList, edit: boolean = true) {

		if (this.checkDashboardRoute()) return null;
		this.YeuCauDuyetGiaService.detail(detail.IdDG).subscribe(res1 => {
			// Kiểm tra nếu kết quả trả về hợp lệ và có trạng thái thành công.
			if (res1 && res1.status == 1) {
				let item = new YeuCauDuyetGiaList();
				item.clear();
				//item.SoPhieu = res2.data;
				item.IdKH = res1.data[0].YeuCauDuyetGiaDetailCT[0].IdKH;
				item.MaKH = res1.data[0].YeuCauDuyetGiaDetailCT[0].MaKH;
				item.TenKH = res1.data[0].YeuCauDuyetGiaDetailCT[0].TenKH;
				item.TrangThai_Code = this.optionsTinhTrang[0].value;
				item.TrangThai_Desc = this.optionsTinhTrang[0].name;
				item.DanhSachHangHoa = res1.data[0].YeuCauDuyetGiaDetailCT;
				const dialogRef = this.dialog.open(YeuCauDuyetGiaEditComponent, {
					
					data: {
						data: item,
						add: true,
						edit: true,
						show_area_1: false,
					},
					maxHeight: '90vh',
					width: '90vw'
				});
				dialogRef.afterClosed().subscribe(res => {
					this.openDialog = false;
					this.loadYeuCauDuyetGiaInit(true);
					if (res == undefined || res == null) {
						return;
					}
					else {
						if (!res.isChange) {
							this.loadYeuCauDuyetGia();
							return;
						}
						if (res.saveNewTTHV.length != 0) {
							this.saveNewTTHV = res.saveNewTTHV;
						}
						if (item.IdDG == 0)
							this.loadYeuCauDuyetGiaInit(true);
						this.loadYeuCauDuyetGia(true);
					}
				});
			}
				
		});
		
		
	}
	//#region Xem chi tiết
	async callDetail(item: YeuCauDuyetGia) {
		if (this.checkDashboardRoute()) return null;
		const dialogRef = this.dialog.open(YeuCauDuyetGiaEditComponent, {
			data: {
				data: item,
				show_area_2: true,
				detail: true,
				matenKH: item.MaKH + ' - ' + item.TenKH,
			},
			maxHeight: '90vh',
			width: '90vw'
		});

		dialogRef.afterClosed().subscribe(res => {
			this.loadYeuCauDuyetGia(true);
			if (res == undefined || res == null) {
				return;
			}
			else {
				this.saveNewTTHV = [];
				this.loadYeuCauDuyetGia(true);
			}
		});
	}
	//#endregion Xem chi tiết

	addYCDGVsNCSPMoi(item: any) {
		if (this.checkDashboardRoute()) return null;
		const dialogRef = this.dialog.open(YeuCauDuyetGiaEditComponent, {
			data: {
				data: item,
				add_yeucauduyetgia: true,
				add_yeucauncspmoi: true,
				show_area_2: true
			},
			maxHeight: '90vh',
			width: '90vw'
		});

		dialogRef.afterClosed().subscribe(res => {
			this.loadYeuCauDuyetGia(true);
			if (res == undefined || res == null) {
				return;
			}
			else {
				this.saveNewTTHV = [];
				this.loadYeuCauDuyetGia(true);
			}
		});
	}

	//#region Chỉnh sửa các trường trên lưới
	resetValueUpdate(columnName: string, item: any) {
		if (columnName == 'SoPhieu')
			this.YeuCauDuyetGiaResult[this.YeuCauDuyetGiaResult.indexOf(item)].SoPhieu = this.tmpYeuCauDuyetGiaResult[this.YeuCauDuyetGiaResult.indexOf(item)].SoPhieu;
	}

	changeValueOfColumn(columnName: string, item: any, event: any, afterUpdate: boolean) {
		if (columnName == 'SoPhieu') {
			if (afterUpdate) {
				this.tmpYeuCauDuyetGiaResult[this.YeuCauDuyetGiaResult.indexOf(item)].SoPhieu = item.SoPhieu
			}
			else {
				this.YeuCauDuyetGiaResult[this.YeuCauDuyetGiaResult.indexOf(item)].SoPhieu = event.target.value.trim();
				//this.updateYeuCauDuyetGia('SoPhieu',item);
			}
		}
	}

	isChangeValue(columnName: string, item: any) {
		if (columnName == 'SoPhieu' && this.YeuCauDuyetGiaResult[this.YeuCauDuyetGiaResult.indexOf(item)].SoPhieu != this.tmpYeuCauDuyetGiaResult[this.YeuCauDuyetGiaResult.indexOf(item)].SoPhieu)
			return true;
		return false;
	}

	ValidateChangeNumberEvent(columnName: string, item: any, event: any) {
		var count = 0;
		for (let i = 0; i < event.target.value.length; i++) {
			if (event.target.value[i] == '.') {
				count += 1;
			}
		}
		var regex = /[a-zA-Z -!$%^&*()_+|~=`{}[:;<>?@#\]]/g;
		var found = event.target.value.match(regex);
		if (found != null) {
			const message = 'Dữ liệu không gồm chữ hoặc kí tự đặc biệt';
			this.layoutUtilsService.showErorr(message);
			return false;;
		}
		if (count >= 2) {
			const message = 'Dữ liệu không thể có nhiều hơn 2 dấu .';
			this.layoutUtilsService.showErorr(message);
			return false;;
		}
		return true;
	}
	//#endregion Chỉnh sửa các trường trên lưới

	//#region Format
	formatNumber(item: string) {
		if (item == '' || item == null || item == undefined) return '';
		return Number(Math.round(parseFloat(item + 'e' + this.fixedPoint)) + 'e-' + this.fixedPoint).toFixed(this.fixedPoint)
	}

	f_currency(value: string): any {
		if (value == null || value == undefined || value == '') value = '0.00';
		let nbr = Number((value.substring(0, value.length - (this.fixedPoint + 1)) + '').replace(/,/g, ""));
		return (nbr + '').replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,") + value.substr(value.length - (this.fixedPoint + 1), (this.fixedPoint + 1));
	}

	f_currency_V2(value: string): any {
		if (value == '-1') return '';
		if (value == null || value == undefined || value == '') value = '0';
		let nbr = Number((value + '').replace(/,/g, ""));
		return (nbr + '').replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
	}

	getFormatDate(v: string = '') {
		if (v != '') {
			return v.includes('T') ? v.replace(/(\d{4})(-)(\d{2})(-)(\d{2})(T)(\d{2})(:)(\d{2})(:)(\d{2}).*$/g, "$5/$3/$1") : v.replace(/(\d{4})(-)(\d{2})(-)(\d{2})/g, "$5/$3/$1");
		}
		return '';
	}
	//#endregion Format

	//#region Lấy danh sách tên trạng thái
	getNameOfTrangThai(TrangThai: number) {
		if (TrangThai == 0)
			return 'Chưa duyệt';
		else if (TrangThai == 1)
			return 'Đã duyệt';
		else if (TrangThai == 2)
			return 'Bị trả lại';
		else if (TrangThai == 4)
			return 'Chờ kiểm tra';
		else if (TrangThai == 5)
			return 'Đang kiểm tra';
		else if (TrangThai == 6)
			return 'Đã kiểm tra';
		return '';
	}
	//#endregion Lấy danh sách tên trạng thái

	//#region Highlight dữ liệu
	highlightNewestRecord(item: any) {
		var index = this.YeuCauDuyetGiaResult.findIndex(x => x.IdDG == item.IdDG && x.SoPhieu == item.SoPhieu);
		if (this.saveNewTTHV.findIndex(x => x == this.YeuCauDuyetGiaResult[index].IdDG) > -1) {
			return true;
		}
		return false;
	}
	//#endregion Highlight dữ liệu

	//#region Focus
	forcusEvents() {
		this.openDialog = false;
		this.changeDetectView();
	}
	//#endregion Focus, Filter

	//#region Lấy css theo trạng thái
	getItemCssClassByStatus(status: any): string {
		switch (status) {
			case "KDYCDG_DANGSOANTHAO":
				return '_phieumoi';
			case "KDYCDG_CHODUYET":
				return '_choxacnhan';
			case "KDYCDG_KHONGDUYET":
				return '_tpkhongduyet';
			case "KDYCDG_HOANTAT":
				return '_hoantat';
			case "KDYCDG_DAHUY":
				return '_dahuy';
			case "KDYCDG_CHOXUATKHO":
				return '_chotpduyet';
			case "KDYCDG_HETHAN":
				return '_hethan';
			case "KDYCDG_CHOXEMXET":
				return '_chogdduyet';
			case "KDYCDG_KHONGDONGY":
				return '_gdkhongduyet';
			default:
				return 'success';
		}
	}
	//#endregion Lấy css theo trạng thái

	//#region Filter function
	SelectAll(event, col) {
		if (event.checked) {
			this.filterGroupDataCheckedFake[col].forEach(element => {
				element.checked = true;
			});
		}
		else {
			this.filterGroupDataCheckedFake[col].forEach(element => {
				element.checked = false;
			});
		}
	}
	isColumnSelectAll(col) {
		if (this.filterGroupDataCheckedFake[col]) {
			let lst_checked = this.filterGroupDataCheckedFake[col].filter(opt => opt.checked).map(opt => opt.value);
			if (lst_checked) {
				if (lst_checked.length != this.filterGroupDataCheckedFake[col].length) {
					return false;
				}
				else {
					return true;
				}
			}
			else {
				return false;
			}
		}
		return false;
	}

	//#endregion Filter function

	//#region Check người tạo với người đang login
	checkUserCreate(item: any) {
		return +item.Nguoitao == this.IdUser;
	}
	//#endregion Check người tạo với người đang login

	//#region Check router
	checkDashboardRoute() {
		if (this.router.url === '/')
			return true;
		return false;
	}
	//#endregion Check router
	isDeleteAndRemove(status: string) {
		return ((status === YeuCauDuyetGia.optionsTinhTrang[4].value) || (status === YeuCauDuyetGia.optionsTinhTrang[6].value));
	}

	deleteItem(item) {
		if (this.checkDashboardRoute()) return null;
		const _sophieu: string = item.SoPhieu;
		const _deleteMessage = `Phiếu yêu cầu duyệt giá ` + _sophieu + ` đã được xóa`;
		const dialogRef = this.layoutUtilsService.POP01(_sophieu);

		dialogRef.afterClosed().subscribe(res => {
			this.forcusEvents();
			if (!res) {
				return;
			}
			this.YeuCauDuyetGiaService.delete(item.IdDGCT).subscribe(res => {
				if (res && res.status === 1) {
					this.layoutUtilsService.showInfo(_deleteMessage);
				}
				else {
					this.layoutUtilsService.showErorr(res.error.message);
				}
				if (this.dataSource.entitySubject.value.length == 1) {
					this.loadYeuCauDuyetGiaPagePre();
				}
				else this.loadYeuCauDuyetGia();
				this.changeDetectView();
			});
		});
	}

	closeItem(item) {
		if (this.checkDashboardRoute()) return null;
		const _sophieu: string = item.SoPhieu;
		const _deleteMessage = `Yêu cầu duyệt giá ` + _sophieu + ` đã được hủy`;
		const dialogRef = this.layoutUtilsService.POP04(_sophieu);

		dialogRef.afterClosed().subscribe(res => {
			this.forcusEvents();
			if (!res) {
				return;
			}
			this.YeuCauDuyetGiaService.cancel(item.IdDGCT).subscribe(res => {
				if (res && res.status === 1) {
					this.layoutUtilsService.showInfo(_deleteMessage);
					this.saveNewTTHV = [item.IdDG];
				}
				else {
					this.layoutUtilsService.showErorr(res.error.message);
				}
				this.loadYeuCauDuyetGia(true);
			});
		});
	}
	//#endregion Thao tác

	isCreate(item: any) {
		var idUser = '';
		this.tokenStorage.getIDUser().subscribe(t => { idUser = t; });
		let element = this.tmpYeuCauDuyetGiaResult.find(x => x.IdDG == item.IdDG);
		if (element != null && (element.NguoiLapPhieu == +idUser)) {
			return true;
		}
		return false;
	}

	// acceptTP(item){
	// 	if(this.checkDashboardRoute())	return null;
	// 	this.openDialog = true;
	// 	const dialogRef = this.dialog.open(YeuCauDuyetGiaEditComponent, {
	// 		data: {
	// 			data: item,
	// 			confirm: true,
	// 			show_area_1: true,
	// 		},
	// 		maxHeight: '90vh',
	// 		width: '90vw'
	// 	});

	// 	dialogRef.afterClosed().subscribe(res => {
	// 		this.openDialog = false;
	// 		if (res == undefined || res == null) {
	// 			return;
	// 		}
	// 		else{
	// 			if (!res.isChange) {
	// 				return;
	// 			}
	// 			if(res.dataAdd.length != 0){
	// 				this.saveNewTTHV = res.dataAdd;
	// 			}
	// 			this.loadYeuCauDuyetGia(true);
	// 		}
	// 	});
	// }
	openKHFeedback(item:any) {
		
		const dialogRef = this.dialog.open(KhachHangFeedbackComponent, {
			data: item,
			maxHeight: '90vh',
			width: '60vw'
		});
		dialogRef.afterClosed().subscribe(res => {
			this.loadYeuCauDuyetGia();
		});
	}
	changeSoPhieuYCBG(event) {
		if (event) {
			this.__idYCBG = event;
			this.loadYeuCauDuyetGia();
			this.router.navigate(['/kd-yeu-cau-bao-gia/lich-su-yeu-cau-duyet-gia/' + this.__idYCBG]);
		}
	}
	changeDetectView() {
		if (!(this.changeDetect as ViewRef).destroyed) {
			this.changeDetect.detectChanges()
		}
	}


	async callServiceFilterInList() {
		var i = 0;
		// var res = await this.DungChungService.listHangHoa().toPromise();
		// if (res && res.status === 1) {
		// 	this.filterGroupDataChecked['MaSP'] = res.data.map(a => {
		// 		i = i + 1;
		// 		return {
		// 			id: i,
		// 			name: a.Ma_Ten_HH,
		// 			value: a.MaHH,
		// 			checked: false,
		// 		}
		// 	})
		// 	this.filterGroupDataChecked['MaSP'].sort(function (a, b) {
		// 		return a.name - b.name;
		// 	})
		// 	this.filterGroupDataCheckedFake = Object.assign({}, this.filterGroupDataChecked);
		// }


		// var res = await this.DungChungService.listKH().toPromise();
		// if (res && res.status === 1) {
		// 	this.filterGroupDataChecked['MaKH'] = res.data.map(a => {
		// 		i = i + 1;
		// 		return {
		// 			id: i,
		// 			name: a.MaKH + ' - ' + a.TenKH,
		// 			value: a.MaKH,
		// 			checked: false,
		// 		}
		// 	})
		// 	this.filterGroupDataChecked['MaKH'].sort(function (a, b) {
		// 		return a.name - b.name;
		// 	})
		// 	this.filterGroupDataCheckedFake = Object.assign({}, this.filterGroupDataChecked);
		// }


		let tmpOptions = YeuCauDuyetGia.optionsTinhTrang;
		this.filterGroupDataChecked['TrangThai'] = tmpOptions.map(x => {

			i = i + 1;
			return {
				id: i,
				name: x.name,
				value: x.value,
				checked: false,
			}
		});
		this.filterGroupDataChecked['TrangThai'].sort(function (a, b) {
			return a.position - b.position;
		})
		this.filterGroupDataCheckedFake = Object.assign({}, this.filterGroupDataChecked);
	}
	LoadDataDropFilter(col) {
		this.tmpfilterText = Object.assign({}, this.filterText);
		if (this.filterGroupDataChecked && this.filterGroupDataCheckedFake && this.filterGroupDataCheckedFake[col] && this.filterGroupDataChecked[col]) {
			this.filterGroupDataCheckedFake[col] = this.filterGroupDataChecked[col].map(x => Object.assign({}, x));
		}
	}
	disableDoneButton(col, isSelect = true) {
		let countChecked = 0;

		if (isSelect) {
			if (this.filterGroupDataCheckedFake && this.filterGroupDataCheckedFake[col]) {
				for (var elementFake of this.filterGroupDataCheckedFake[col]) {
					if (elementFake.checked) {
						countChecked++;
					}
				}
			}
			if (countChecked > 0) {
				this.disableButtonFilter[col] = false;
			}
			else {
				this.disableButtonFilter[col] = true;
			}
		} else {
			if (this.filterGroupDataCheckedFake && this.filterGroupDataCheckedFake[col]) {
				if (this.filterGroupDataCheckedFake[col].length > 0) {
					this.disableButtonFilter[col] = false;
				}
				else {
					this.disableButtonFilter[col] = true;
				}
			}
		}
	}
	filterGroupWithTextFilter(columnName: string) {
		let search = this.tmpfilterText[columnName]

		if (!search) {
			this.filterGroupDataCheckedFake[columnName] = this.filterGroupDataChecked[columnName].map(x => Object.assign({}, x));
			return;
		} else {
			search = search.toLowerCase();
		}

		this.filterGroupDataCheckedFake[columnName] = this.filterGroupDataChecked[columnName].filter(
			ts => ts.name.toLowerCase().indexOf(search) > -1)

		this.changeDetect.detectChanges();
	}

	filterHead(col, isSelect = true) {
		if (isSelect) {
			if (this.filterGroupDataCheckedFake && this.filterGroupDataCheckedFake[col]) {
				for (var elementFake of this.filterGroupDataCheckedFake[col]) {

					let index = this.filterGroupDataChecked[col].findIndex(x => x.id == elementFake.id);

					if (index > -1)
						this.filterGroupDataChecked[col][index].checked = elementFake.checked;
				}
				this.filterGroupData[col] = [];
				this.filterGroupArray[col] = [];
				this.filterGroupArray[col] = this.filterGroupDataCheckedFake[col]
					.filter(opt => opt.checked);
				this.filterGroupData[col] = this.filterGroupDataCheckedFake[col]
					.filter(opt => opt.checked).map(op => op.value);

				this.filterGroupDataCheckedFake[col] = this.filterGroupDataChecked[col].map(x => Object.assign({}, x));
				this.tmpfilterText[col] = '';
			}
			this.filterText = Object.assign({}, this.tmpfilterText);
			if (this.filterText) {
				this.filterConfiguration();
			}
			this.loadYeuCauDuyetGia();
			this.isClearAll = this.checkFilterHasValue(this.filterGroupDataChecked, 'ALL');
		} else {
			if (this.filterGroupDataCheckedFake) {
				if (!this.filterGroupDataCheckedFake[col]) {
					this.remove('', col, false);
				} else {
					this.filterGroupData[col] = [];
					this.filterGroupArray[col] = [this.filterGroupDataCheckedFake[col]];
					this.filterGroupData[col] = [this.filterGroupDataCheckedFake[col]];
					if (this.filterGroupData[col])
						this.tmpfilterText[col] = '';
				}
			}
			this.filterText = Object.assign({}, this.tmpfilterText);
			if (this.filterText) {
				this.filterConfiguration();
			}
			this.loadYeuCauDuyetGia();
			this.isClearAll = this.checkFilterHasValue(this.filterGroupDataCheckedFake, col, false);
			this.filterGroupDataCheckedFake[col] = '';
		}
	}
	remove(item, col, isSelect = true) {
		if (isSelect) {
			let _index = this.filterGroupDataChecked[col].findIndex(x => x.value == item.value);
			if (_index > -1) {
				this.filterGroupDataChecked[col][_index].checked = false;
				this.filterGroupData[col] = [];
				this.filterGroupArray[col] = [];
				this.filterGroupArray[col] = this.filterGroupDataChecked[col]
					.filter(opt => opt.checked);
				this.filterGroupData[col] = this.filterGroupDataChecked[col]
					.filter(opt => opt.checked).map(op => op.value);

				if (this.filterGroupData[col] != null && this.filterGroupData[col].length == 0) {
					this.filterGroupData[col] = null
					this.filterText[col] = '';
					this.disableButtonFilter[col] = true;
				}
				this.loadYeuCauDuyetGia();
			}
		} else {
			let _index = this.filterGroupDataCheckedFake[col].length;
			if (_index > -1) {
				this.filterGroupData[col] = [];
				this.filterGroupArray[col] = [];
				this.filterGroupArray[col] = [];
				this.filterGroupData[col] = [];

				if (this.filterGroupData[col] != null && this.filterGroupData[col].length == 0) {
					this.filterGroupData[col] = null
					this.filterText[col] = '';
					this.disableButtonFilter[col] = true;
				}
				this.filterGroupDataCheckedFake[col] = '';
				this.loadYeuCauDuyetGia();
			}
		}

	}
	checkFilterHasValue(data, col, isSelect = true) {
		let _count = 0;
		if (isSelect) {
			if (col == 'ALL' && data) {//check all column
				for (var key in data) {
					if (data.hasOwnProperty(key)) {
						if (data[key]) {
							let _arrflt = data[key].filter(opt => opt.checked);
							_count += _arrflt ? _arrflt.length : 0;
						}
					}
				}
				let _text = "";
				for (var key in this.filterText) {
					if (this.filterText.hasOwnProperty(key)) {
						_text += this.filterText[key];
					}
				}
				if (_count > 0 || _text) {
					return true;
				}
			}
			else {//check in 1 column
				if (data && data[col]) {
					let _arrflt = data[col].filter(opt => opt.checked);
					_count += _arrflt ? _arrflt.length : 0;
				}
				if (_count > 0) {
					return true;
				}
			}
		} else {
			if (data && data[col] && data[col].length > 0) {
				if (data[col].length > 0) {
					return true;
				}
			}
		}
		return false;
	}
	showClearAllButton() {
		let _count = 0;
		for (var key in this.filterGroupArray) {
			if (this.filterGroupArray.hasOwnProperty(key)) {
				if (this.filterGroupArray[key]) {
					let _arrflt = this.filterGroupArray[key].filter(opt => opt.checked);
					if (_arrflt.length == 0 && this.filterGroupArray[key].length == 1) {
						_arrflt = this.filterGroupArray[key].filter(opt => opt);
					}
					_count += _arrflt ? _arrflt.length : 0;
				}
			}
		}
		let _text = "";
		for (var key in this.filterText) {
			if (this.filterText.hasOwnProperty(key)) {
				_text += this.filterText[key];
			}
		}
		if (_count > 0 || _text) {
			this.isClearAll = true;
		}
		else {
			this.isClearAll = false;
		}
	}
	Clear() {
		this.filterGroupData = [];
		this.filterGroupArray = [];
		for (var key in this.filterGroupDataChecked) {
			if (this.filterGroupDataChecked.hasOwnProperty(key)) {
				if (this.filterGroupDataChecked[key]) {
					this.filterGroupDataChecked[key].forEach(element => {
						element.checked = false;
					});
					this.disableButtonFilter[key] = true;
				}
			}
		}
		for (var key in this.filterText) {
			if (this.filterText.hasOwnProperty(key)) {
				this.filterText[key] = "";
			}
		}
		this.filterText = {};
		this.tmpfilterText = Object.assign({}, this.filterText);
		this.isClearAll = false;

		this.loadYeuCauDuyetGia();
	}
	removeText(col) {
		this.filterText[col] = "";
		this.tmpfilterText = Object.assign({}, this.filterText);
		this.loadYeuCauDuyetGia();
	}
	formatDate(date) {
		return moment(date).format("DD/MM/YYYY");
	}


	/* ----------------------------- XUẤT EXCEL -------------------------------- */
	ExportFileExcel() {
		this.waittingExport = true;
		this.flagExportFile = true;
		this.changeDetectView();

		setTimeout(() => { this.ExportFile(); }, 2000);
	}

	ExportFile() {
		let ele = document.getElementById("table");
		const ws: xlsx.WorkSheet = xlsx.utils.table_to_sheet(ele, { dateNF: 'dd/mm/yyyy;@', cellDates: true, raw: true });

		const wb: xlsx.WorkBook = xlsx.utils.book_new();
		xlsx.utils.book_append_sheet(wb, ws, 'DS_YCDG');

		xlsx.writeFile(wb, 'DS_YCDG_' + moment().format("hhmmssDDMMYYYY") + '.xlsx');
		this.flagExportFile = false;
		this.waittingExport = false;
		this.changeDetectView();
	}
	/* ---------------------------------------------------------------------- */

	createDHB(item: any) {
		let data = new KDDatHang();
		data.clear();
		data.LoaiPhieu = 1;
		data.IdKH = item.IdKH;
		data.MaKH = item.MaKH;
		data.TenKH = item.TenKH;

		let tmp = {
			"IdCt": item.IdDGCT,
			"SoPhieuYCDG": item.SoPhieu,
			"IdHH": item.IdHH,
			"MaHH": item.MaHH,
			"TenHH": item.TenHH,
			"QuyCach": item.QuyCachDongGoi,
			"DVT": item.IdDVT,
			"TenDVT": item.TenDVT,
			"DonGia": item.GiaDeNghiBan,
			"SoLuong": item.SoLuong,
			"NgayYCGH": item.NgayYeuCauGiaoHang,
			"PhanTramThueVAT": item.PhanTramThueVAT,
			"TonKho": item.TonKho
		};

		let listData = []
		listData.push(tmp);

		const dialogRef = this.dialog.open(KDDatHangEditComponent, {
			data: {
				data: data,
				them_moi: true,
				listData: listData,
			},
			maxHeight: '90vh',
			width: '90vw'
		});
		dialogRef.afterClosed().subscribe(res => {
			if (res && res.isChange) {
				this.router.navigate(['don-hang-ban', {}], { state: { saveNewTTHV: res.dataAdd } });
			}
		});
	}
}
